import Card, { CardBody, CardHeader, CardTitle } from "../../../../bootstrap/Card"
import Button from "../../../../bootstrap/Button"
import Checks from "../../../../bootstrap/forms/Checks"

const CategoriesConfigStep = ({ 
    allCategories,
    allProducts,
    selectedCategories, 
    onCategoryToggle, 
    onSelectAll, 
    onClear 
}) => {
    return (
        <Card>
            <CardHeader>
                <CardTitle>Seleção de Categorias</CardTitle>
            </CardHeader>
            <CardBody>
                <div className="d-flex gap-2 mb-4">
                    <Button color="dark" size="sm" isLight onClick={onSelectAll}>
                        Selecionar Todas
                    </Button>
                    <Button color="dark" size="sm" isLight onClick={onClear}>
                        Limpar
                    </Button>
                </div>
                <div className="row">
                    {allCategories.map(cat => {
                        const isSelected = selectedCategories.some(c => c.app_category_id === cat.id)
                        const activeProductsCount = allProducts.filter(p => 
                            cat.products?.includes(p.id)
                        ).length
                        return (
                            <div key={cat.id} className="col-md-6 mb-3">
                                <Card 
                                    className={isSelected ? 'border-dark bg-light' : ''} 
                                    onClick={() => onCategoryToggle(cat)}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <CardBody className="p-3">
                                        <Checks 
                                            type="checkbox" 
                                            checked={isSelected} 
                                            readOnly 
                                            className="me-2" 
                                        />
                                        <strong>{cat.name}</strong>
                                        <small className="text-muted ms-2">
                                            ({activeProductsCount} produtos)
                                        </small>
                                    </CardBody>
                                </Card>
                            </div>
                        )
                    })}
                </div>
            </CardBody>
        </Card>
    )
}

export default CategoriesConfigStep
